import { useQuery, useMutation } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import {
  inputTypesApi,
  type CreateInputTypeRequest,
  type UpdateInputTypeRequest,
} from "../services/inputTypesApi";

export const useInputTypes = (enabled = true) => {
  return useQuery({
    enabled,
    queryKey: ["inputTypes"],
    queryFn: inputTypesApi.getAllInputTypes,
  });
};

export const useActiveInputTypes = () => {
  return useQuery({
    queryKey: ["inputTypes", "active"],
    queryFn: inputTypesApi.getActiveInputTypes,
  });
};

export const useInputTypeById = (id: string) => {
  return useQuery({
    queryKey: ["inputTypes", id],
    queryFn: () => inputTypesApi.getInputTypeById(id),
  });
};

export const useInputTypeByCode = (code: string) => {
  return useQuery({
    queryKey: ["inputTypes", "code", code],
    queryFn: () => inputTypesApi.getInputTypeByCode(code),
  });
};

export const useCreateInputType = () => {
  return useMutation({
    mutationFn: (payload: CreateInputTypeRequest) =>
      inputTypesApi.createInputType(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["inputTypes"] });
      queryClient.invalidateQueries({
        queryKey: ["inputTypes", "active"],
      });
    },
  });
};

export const useUpdateInputType = () => {
  return useMutation({
    mutationFn: (payload: UpdateInputTypeRequest) =>
      inputTypesApi.updateInputType(payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["inputTypes"] });
      queryClient.invalidateQueries({
        queryKey: ["inputTypes", data.id],
      });
      queryClient.invalidateQueries({
        queryKey: ["inputTypes", "active"],
      });
    },
  });
};

export const useDeactivateInputType = () => {
  return useMutation({
    mutationFn: (id: string) => inputTypesApi.deactivateInputType(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["inputTypes"] });
      queryClient.invalidateQueries({
        queryKey: ["inputTypes", "active"],
      });
    },
  });
};